import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { VolumeFragment } from "@/components/price/Volume.fragment"

export const ProfilePreviewTooltipCollectionTableRowFragment = graphql(
  `
    fragment ProfilePreviewTooltipCollectionTableRow on ProfileCollection {
      id
      ownership {
        id
        totalQuantity
        value {
          ...Volume
        }
      }
      collection {
        id
        name
        slug
        isVerified
        imageUrl
        ...CollectionLockup
      }
    }
  `,
  [VolumeFragment, CollectionLockupFragment],
)

export const ProfilePreviewTooltipCollectionTableFragment = graphql(
  `
    fragment ProfilePreviewTooltipCollectionTable on ProfileCollection {
      ...ProfilePreviewTooltipCollectionTableRow
    }
  `,
  [ProfilePreviewTooltipCollectionTableRowFragment],
)
